import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/checkout/return")({
  head: () => ({
    meta: [
      { title: "Payment Complete — The Hospitality Reserve" },
      { name: "description", content: "Your engagement payment has been received. The bartender has been notified and your booking is confirmed." },
      { name: "robots", content: "noindex,nofollow" },
    ],
    links: [{ rel: "canonical", href: "https://thehospitalityreserve.com/checkout/return" }],
  }),
  validateSearch: (search: Record<string, unknown>): { session_id?: string } => ({
    session_id: typeof search.session_id === "string" ? search.session_id : undefined,
  }),
  component: ReturnPage,
});

function ReturnPage() {
  const { session_id } = Route.useSearch();
  return (
    <main className="min-h-screen bg-background flex items-center justify-center p-8">
      <div className="max-w-md text-center border border-border bg-card p-10">
        <p className="tracking-wide-luxury text-accent">Confirmed</p>
        <h1 className="mt-3 font-display text-3xl">Payment received</h1>
        <span className="gold-divider mx-auto mt-4 block w-12" />
        <p className="mt-6 text-sm text-muted-foreground">
          {session_id
            ? "Your engagement is confirmed. The bartender has been notified."
            : "No session reference returned, but if you completed checkout, your engagement is confirmed."}
        </p>
        <Link
          to="/venue"
          className="mt-8 inline-block border border-foreground px-6 py-3 tracking-wide-luxury text-xs hover:bg-foreground hover:text-background"
        >
          Return to your register
        </Link>
      </div>
    </main>
  );
}
